import discardNullableValues from '@haaretz/s-common-utils/discardNullableValues';
import useClientQuery from '../../common/useClientQuery';
import { USER_RECOMMENDATIONS } from '../../consts';
const CACHE_TIME = 1000 * 10; // 10 seconds
export default function useUserRecommendationsPersonal({ email, page, site }) {
    const searchParams = new URLSearchParams(discardNullableValues({
        email,
        page,
        site,
        bs: 'true'
    }));
    return useClientQuery({
        cacheKey: 'userRecommendations',
        url: USER_RECOMMENDATIONS,
        searchParams,
        clientOptions: {
            useErrorBoundary: false,
            cacheTime: CACHE_TIME,
            staleTime: CACHE_TIME,
            retry: false
        }
    });
}

//# sourceMappingURL=useUserRecommendationsPersonal.js.map